import * as z from 'zod';

export const statusSchema = z.enum(['inactive', 'active']);
export type StatusSchema = z.infer<typeof statusSchema>;

export const statusMutationSchema = statusSchema.nullable();
export const statusQuerySchema = z.enum(['', 'inactive', 'active']).nullable();
export const statusFormSchema = z.object({
  name: z.string(),
  value: z.enum(['', 'inactive', 'active']),
});

export type StatusQuerySchema = z.infer<typeof statusQuerySchema>;
export type StatusFormSchema = z.infer<typeof statusFormSchema>;
export type StatusMutationSchema = z.infer<typeof statusMutationSchema>;

export const defaultStatus: StatusFormSchema = { name: 'Active', value: 'active' };

export function strToStatus(status: StatusQuerySchema): StatusFormSchema {
  return isStatusTrue(status) ? statusOptions[1] : statusOptions[2];
}

export function statusToStr(status?: StatusFormSchema): StatusSchema {
  return status?.value || 'active';
}

export function statusToStrByName(status?: StatusFormSchema): string {
  return status?.name || 'Active';
}

export const statusOptions: StatusFormSchema[] = [
  { name: 'None', value: '' },
  defaultStatus,
  { name: 'Inactive', value: 'inactive' },
];

export const isStatusTrue = (status: StatusFormSchema | string | null) => {
  if (typeof status === 'string') {
    return status !== 'inactive';
  }

  return status?.value !== 'inactive';
};
